import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {NotificationDto} from "../../types/notification";

interface NotificationState {
    data: NotificationDto[],
    deltaNotifications: NotificationDto[],
    loading: boolean,
    deleteLoading: boolean,
    error: string | null,
    // Read notification batching state
    seenNotificationIds: number[],
    processedNotificationIds: number[],
    readBatchTimeout: boolean
}

const initialState: NotificationState = {
    data: [],
    deltaNotifications: [],
    loading: false,
    error: null,
    deleteLoading: false,

    seenNotificationIds: [],
    processedNotificationIds: [],
    readBatchTimeout: false
}

export const notificationSlice = createSlice({
    name: 'notification',
    initialState: initialState,
    reducers: {
        setNotifications: (state, action: PayloadAction<NotificationDto[]>) => {
            state.data = action.payload
        },
        setDeltaNotifications: (state, action: PayloadAction<NotificationDto[]>) => {
            state.deltaNotifications = action.payload
        },
        clearDeltaNotifications: (state) => {
            state.deltaNotifications = []
        },
        setNotificationsLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload
        },
        setDeleteNotificationsLoading: (state, action: PayloadAction<boolean>) => {
            state.deleteLoading = action.payload
        },
        setNotificationsError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload
        },
        // Read notification batching actions
        addSeenNotification: (state, action: PayloadAction<number>) => {
            const notificationId = action.payload;
            if (!state.seenNotificationIds.includes(notificationId) && 
                !state.processedNotificationIds.includes(notificationId)) {
                state.seenNotificationIds.push(notificationId);
            }
        },
        markNotificationsAsProcessed: (state, action: PayloadAction<number[]>) => {
            const processedIds = action.payload;
            // Add to processed list
            processedIds.forEach(id => {
                if (!state.processedNotificationIds.includes(id)) {
                    state.processedNotificationIds.push(id);
                }
            });
            // Remove from seen list
            state.seenNotificationIds = state.seenNotificationIds.filter(
                id => !processedIds.includes(id)
            );
        },
        setReadBatchTimeout: (state, action: PayloadAction<boolean>) => {
            state.readBatchTimeout = action.payload;
        },
        clearReadNotificationState: (state) => {
            state.seenNotificationIds = [];
            state.processedNotificationIds = [];
            state.readBatchTimeout = false;
        },
    }
});

export const { 
    setNotifications,
    setNotificationsLoading,
    setNotificationsError,
    setDeltaNotifications,
    clearDeltaNotifications,
    setDeleteNotificationsLoading,
    // Read notification actions
    addSeenNotification,
    markNotificationsAsProcessed,
    setReadBatchTimeout,
    clearReadNotificationState,
} = notificationSlice.actions;

export default notificationSlice.reducer;

